module.exports = __webpack_public_path__ + "img/webhao_icon.7abb1de5.png";